import actionTypes from 'utils/actions/action-types';

export default (state = '', action) => {
  switch (action.type) {
    case actionTypes.FETCH_POSTER_URL_SUCCESS: {
      return action.url;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/poster/poster-url.js